<template>
  <Menu />
  <Zapis />
  <Phone />
  <div class="pri">
    <div class="cen">
      <div class="lef">
        <div class="mr"></div>
        <h1>Корнилова <br>
          Эльмира Мяксутовна</h1>
        <h2>врач-стоматолог-терапевт, главный врач</h2>
        <p>
          Общий медицинский стаж с 1993 года. Стаж по специальности с 1994 года. Диплом о высшем образовании, выдан Федеральным государственным образовательным учреждением высшего профессионального образования «Чувашский государственный университет им. И.Н. Ульянова» в 1993 году, специальность «Стоматология», квалификация «врач-стоматолог». Удостоверение о прохождении интернатуры по специальности «врач-стоматолог-терапевт» выдано 28.06.1994г. Министерство здравоохранения Чувашской Республики ЧГУ им. И.Н. Ульянова. Периодическая аккредитация по специальности «Стоматология терапевтическая» пройдена в ФГБОУ ДПО РМАНПО Минздрава России в 2025 году, срок действия аккредитации до 31.10.2030 года. Диплом о профессиональной переподготовке по специальности «Организация здравоохранения и общественное здоровье» выдан ГАУ ДПО «Институт усовершенствования врачей» Минздрава Чувашской Республики в 2016 году. Удостоверение о повышении квалификации по специальности «Организация здравоохранения и общественное здоровье» выдано ООО «Центр Профессиональной Компетенции» в 2025 году. <br>
<b>График работы: по скользящему графику.</b> <br>
Персональные данные размещены на сайте на основании Постановления Правительства РФ от 11 мая 2023г. №736 и с согласия субъекта персональных данных, разрешенных для распространения. Запреты и условия на обработку неограниченным кругом лиц персональных данных не установлены.

        </p>
      </div>
      <div class="rig">
        <img class='ii' alt="" src="../assets/doc1.jpg" />
      </div>
    </div>
  </div>
  <Map />
  <Foot />
</template>

<script>
import Menu from '@/components/Menu.vue'
import Zapis from '@/components/Zapis.vue'
import Phone from '@/components/Phone.vue'
import Map from '@/components/Map.vue'
import Foot from '@/components/Foot.vue'

export default {
  name: 'PriceView',
  components: {
    Menu,
    Zapis,
    Phone,
    Map,
    Foot,
  }
}
</script>

<style scoped>

.pri {
  background-color: #f5ee92;
  height: 100vh;
  margin-top: -7.5vh;
}

.cen {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(530px, 1fr));
  margin: 0 auto;
}

.mr {
  height: 5vh;
}

h1 {
  font-size: 3vw;
  margin-left: 5vw;
}

h2 {
  font-size: 1.8vw;
  margin-left: 5vw;
}

p {
  margin-left: 5vw;
  margin-top: 5vh;
  font-size: 0.9vw;
  width: 40vw;
  line-height: 3.5vh;
}

.ii {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  object-fit: cover;
}

@media (max-width: 790px) {

  .pri {
    height: auto;
    margin-top: 0;
  }

  .cen {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  }

  h1 {
    font-size: 28px;
  }

  h2 {
    font-size: 20px;
  }

  p {
    font-size: 14px;
    width: 80vw;
  }

}

</style>

